if (window.location.pathname.includes("/collections")) {
    const target = document.querySelector("#ProductGridContainer");

    if (target) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(async (mutation) => {
        if (mutation.target === target) {
            console.log('test')
             const res = await BSS_B2B.storage.productStorage.load();
                    if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                        await BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                            ...res,
                        });
                    }
        }
        });
    });

    observer.observe(target, {
        childList: true,
        subtree: false 
    });
    }
}